import React from 'react';

import { RightIconPositionWrapper as CompiledRightIconPositionWrapper } from './right-icon-position-wrapper-compiled';

export const RightIconPositionWrapper = (
	props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>,
): React.JSX.Element => <CompiledRightIconPositionWrapper {...props} />;
